import { BadgeFields } from '@/widgets/Product/models';

import { ProductType } from '@/server/services/core/product/models';
import { ProductBatteryType } from '@/server/services/core/productBattery/models';

export const CAR_BATTERY_VEHICLE_TYPE_ID = 'car-battery';
export const MOTOR_BATTERY_VEHICLE_TYPE_ID = 'motor-battery';

export const vehicleTypeBatteryTitle = {
    [CAR_BATTERY_VEHICLE_TYPE_ID]: 'باتری خودرو',
    [MOTOR_BATTERY_VEHICLE_TYPE_ID]: 'باتری موتورسیکلت'
};

export const vehicleTypeTitle = {
    [CAR_BATTERY_VEHICLE_TYPE_ID]: 'خودرو',
    [MOTOR_BATTERY_VEHICLE_TYPE_ID]: 'موتورسیکلت'
};

export const vehicleApiTypeId = {
    [CAR_BATTERY_VEHICLE_TYPE_ID]: 'CAR',
    [MOTOR_BATTERY_VEHICLE_TYPE_ID]: 'MOTORCYCLE'
} as const;

export const vehicleTypeApiToRouteId = {
    CAR: CAR_BATTERY_VEHICLE_TYPE_ID,
    MOTORCYCLE: MOTOR_BATTERY_VEHICLE_TYPE_ID
};

export const vehicleBatteryPageTitle = {
    [CAR_BATTERY_VEHICLE_TYPE_ID]: {
        headerTitle: 'درخواست باتری خودرو',
        title: 'لطفا اطلاعات برند و مدل خودرو خود را وارد کنید.',
        inputPlaceholder: 'برند یا مدل ماشینت رو بنویس...'
    },
    [MOTOR_BATTERY_VEHICLE_TYPE_ID]: {
        headerTitle: 'درخواست باتری موتورسیکلت',
        title: 'لطفا اطلاعات برند و مدل موتورسیکلت خود را وارد کنید.',
        inputPlaceholder: 'برند یا مدل موتورسیکلتت رو بنویس...'
    }
};

export const batteryOrderStatusTitles = {
    INITIAL: { id: 'INITIAL', color: 'primary', title: 'ایجاد شده' },
    PENDING_ADDRESS: { id: 'PENDING_ADDRESS', color: 'warning', title: 'در انتظار ثبت آدرس' },
    PENDING_ANCILLARY_SERVICES: {
        id: 'PENDING_ANCILLARY_SERVICES',
        title: 'در انتظار انتخاب سرویس‌های اضافی',
        color: 'warning'
    },
    BEFORE_PAYMENT: { id: 'BEFORE_PAYMENT', color: 'warning', title: 'در انتظار پرداخت' },
    PENDING_PAYMENT: { id: 'PENDING_PAYMENT', color: 'warning', title: 'در حال پرداخت' },
    PAID: { id: 'PAID', color: 'success', title: 'پرداخت شده' },
    PENDING_ASSIGN_TO_INSTALLER: {
        id: 'PENDING_ASSIGN_TO_INSTALLER',
        color: 'warning',
        title: 'در انتظار تایید توسط کارشناس'
    },
    ASSIGNED_TO_INSTALLER: {
        id: 'ASSIGNED_TO_INSTALLER',
        color: 'success',
        title: 'تایید شده توسط کارشناس'
    },
    PENDING_EXTRA_AMOUNT_PAYMENT: {
        id: 'PENDING_EXTRA_AMOUNT_PAYMENT',
        color: 'warning',
        title: 'در انتظار پرداخت اختلاف قیمت باتری'
    },
    CANCELED: { id: 'CANCELED', color: 'error', title: 'لغو شده' },
    COMPLETED: { id: 'COMPLETED', color: 'success', title: 'تحویل شده' }
};

export const batteryHeights = {
    SHORT: 'پایه کوتاه',
    MEDIUM: 'پایه متوسط',
    LONG: 'پایه بلند'
};

export const batteryPoles = {
    L: 'قطب چپ - موافق',
    R: 'قطب راست - مخالف'
};

export const BATTERY_PRODUCT_CAR_BEST_SELLER_AMPERES = [50, 55, 60];
export const BATTERY_PRODUCT_MOTOR_BEST_SELLER_AMPERES = [6, 7];

export const BATTERY_PRODUCT_CAR_CATEGORY_ID = 1;
export const BATTERY_PRODUCT_MOTOR_CATEGORY_ID = 2;

export const batteryBadges = (product: ProductType & Partial<ProductBatteryType>): BadgeFields[] => [
    ...(product.height
        ? [
              {
                  color: 'default' as const,
                  title: batteryHeights[product.height]
              }
          ]
        : []),
    ...(product.pole
        ? [
              {
                  color: 'success' as const,
                  title: batteryPoles[product.pole]
              }
          ]
        : [])
];

export const isSuggestedBattery = (product: ProductType & Partial<ProductBatteryType>) =>
    product.available && (product.brand.name.includes('تینو') || product.brand.name.includes('پلاس'));

export const batteryGiftTitle = (product: ProductType & Partial<ProductBatteryType>) =>
    product.available && product.brand.name.includes('اِکسون') ? 'آچار و دستکش هدیه' : '';

export const BATTERY_PRODUCT_HIDDEN_DISCOUNT_PERCENTAGE = 99;
export const BATTERY_CHOICE_DEFAULT_BUTTON_TITLE = 'انتخاب و ادامه';
